module.exports = {
	"name": "fireadmin",
	"version": "5.1.0",
	"private": true,
	"dependencies": {
		"child_process": "^1.0.2",
		"childprocess": "^2.0.2",
		"draft-js": "^0.10.1",
		"draftjs-to-html": "^0.7.2",
		"ffmpeg": "0.0.4",
		"firebase": "^4.12.0",
		"firebase-paginator": "github:mobidonia/firebase-paginator",
		"fluent-ffmpeg": "^2.1.2",
		"halogen": "^0.2.0",
		"md5": "^2.2.1",
		"mobidonia-firebase-paginator": "github:mobidonia/firebase-paginator",
		"moment": "^2.19.2",
		"react": "^15.4.2",
		"react-color": "^2.13.5",
		"react-compound-slider": "^0.20.0",
		"react-datetime": "^2.11.1",
		"react-dom": "^15.4.2",
		"react-draft-wysiwyg": "^1.10.4",
		"react-google-maps": "^9.2.2",
		"react-icons": "^2.2.5",
		"react-router": "^3.0.2",
		"react-skylight": "^0.4.2",
		"react-sortable-hoc": "^0.6.8",
		"recompose": "^0.26.0",
		"superagent": "^3.5.1",
		"tablefilter": "^0.6.56",
		"to-case": "^2.0.0"
	},
	"devDependencies": {
		"react-scripts": "0.9.5"
	},
	"scripts": {
		"start": "react-scripts start",
		"build": "react-scripts build",
		"test": "react-scripts test --env=jsdom",
		"eject": "react-scripts eject"
	}
};


//////////////////
// WEBPACK FOOTER
// ./package.json
// module id = 738
// module chunks = 0